// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Progress} from "reactstrap";
import React from "react";
import type {Caller} from "../QueryPage";

export type ResendActivationEmailModalStateProps = {
    open: boolean,
    ssoUid?: string,
    caller: Caller,
    isLoading: boolean,
    error: any
}

export type ResendActivationEmailModalDispatchProps = {

    resendActivationEmail: (ssoUid: string, caller: Caller) => any,
    closeModal: () => any
}

type ResendActivationEmailModalProps = ResendActivationEmailModalStateProps & ResendActivationEmailModalDispatchProps;

export default function ResendActivationEmailModal(props: ResendActivationEmailModalProps) {


    return (
        <Modal isOpen={props.open} toggle={() => {

            if (!props.isLoading) {
                props.closeModal();
            }
        }}>
            <ModalHeader toggle={() => {
                if (!props.isLoading) {
                    props.closeModal();
                }
            }}>Warning</ModalHeader>
            <ModalBody>
                {
                    !props.isLoading && !props.error &&
                    <span>Are you sure to resend the Activation Email?</span>
                }
                {
                    !props.isLoading && props.error &&
                    <Alert color={"danger"}>Failed. Please try again!</Alert>
                }
                {
                    props.isLoading &&
                    <span>OK. We are resending the email..</span>
                }

                {
                    props.isLoading &&

                    (<Progress animated color="danger" value="100" />)
                }
            </ModalBody>
            <ModalFooter>
                {
                    !props.isLoading && !props.error &&

                    [<Button key={1} color="primary" onClick={() => {
                        if (typeof props.ssoUid !== 'undefined') {

                                props.resendActivationEmail(props.ssoUid, props.caller);
                        }
                    }}>Resend</Button>,
                        <Button key={2} color="secondary" onClick={() => {

                            if (!props.isLoading) {
                                props.closeModal();
                            }
                        }}>Cancel</Button>]
                }

            </ModalFooter>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/components/sso/ResendActivationEmailModal.js